import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth, useShouldCompleteProfile } from '../../hooks';
import { PROFILE_PATH } from '../../shared-paths';

type Props = {
  withAuth?: boolean;
  withoutAuth?: boolean;
  children: ReactNode;
};

export const AuthRedirect = ({ withAuth, withoutAuth, children }: Props) => {
  const { isLoggedIn } = useAuth();
  const isProfileIncomplete = useShouldCompleteProfile();
  const location = useLocation();
  const toProfile = isProfileIncomplete && location.pathname !== PROFILE_PATH;
  const redirectTo = (location.state as { from?: string })?.from || '/';

  if (toProfile) {
    return <Navigate to={PROFILE_PATH} />;
  }

  if (withAuth) {
    return !isLoggedIn ? <Navigate to="/" /> : <>{children}</>;
  }

  if (withoutAuth) {
    return isLoggedIn ? <Navigate to={redirectTo} /> : <>{children}</>;
  }

  return <>{children}</>;
};
